// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"uo-z","slideIn":"vo-z"};